import {
  FormControl,
  FormHelperText,
  FormLabel,
  Typography,
  useTheme,
} from '@mui/material';
import { useContext } from './context';

export function InputsHeader({ title, subtitle, name, required, sx }) {
  const theme = useTheme();

  const { getError } = useContext();
  const error = getError(name);

  return (
    <FormControl error={Boolean(error)} sx={{ mb: 1, ...sx }}>
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {title}
      </Typography>
      <FormLabel
        component={Typography}
        required={required}
        sx={{ ...theme.typography.subtitle2 }}
      >
        {subtitle}
      </FormLabel>
      {error && <FormHelperText sx={{ m: 0 }}>{error}</FormHelperText>}
    </FormControl>
  );
}
